import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Button, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, MenuItem, Select, FormControl, InputLabel, TextField, Grid } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import { POINT_RECORD_TYPES, POINT_RECORD_TYPE_MAP } from "src/config/constants";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";
import MerchantInfo from "src/components/common/MerchantInfo";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";

const types = Object.values(POINT_RECORD_TYPES);

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "nickname", label: "用户", alignRight: false },
  { id: "amount", label: "数额", alignRight: false },
  { id: "current", label: "可用积分", alignRight: false },
  // { id: "currentLocked", label: "冻结积分", alignRight: false },
  { id: "type", label: "类型", alignRight: false },
  { id: "detail", label: "详情", alignRight: false },
  { id: "remark", label: "备注", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "操作" },
];

const moreMenus = [
  // { title: "编辑", icon: iconEdit2 }
];

export default function PointRecord() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    isMer: 0,
    category: 1,
    version: 1,
    createdAt: null
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/point/record/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/user/detail/${row.uid}`);
    }
  };

  async function handleExport() {
    const { data, msg } = await asyncRequest({
      path: "/point/record/export",
      data: filter,
    });

    alert(msg, "success");
  }

  const emptyRows = filter.size - items.length;
  const isUserNotFound = items.length === 0;

  return (
    <Page title="积分明细">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            积分明细
          </Typography>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems} onExport={handleExport}>
            <Grid container gap={1}>
            <Grid item lg={6} sm={6} md={3}>
                <MyDateRangePicker
                  value={filter.createdAt}
                  onChange={(val) => {
                    setFilter({
                      ...filter,
                      createdAt: val,
                    });
                  }}
                />
              </Grid>

              <Grid item sm={6} md={3}>
                <TextField
                  style={{ width: 200 }}
                  label="用户ID"
                  size="small"
                  placeholder="用户ID"
                  autoComplete="off"
                  id="uid"
                  value={filter.uid}
                  onChange={(e) => {
                    handleFilterChange("uid", e.target.value);
                  }}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <TextField
                  style={{ width: 200 }}
                  label="订单号"
                  size="small"
                  placeholder="订单号"
                  autoComplete="off"
                  id="orderSN"
                  value={filter.orderSN}
                  onChange={(e) => {
                    handleFilterChange("orderSN", e.target.value);
                  }}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <FormControl>
                  <InputLabel size="small">版本 </InputLabel>
                  <Select
                    label="版本 "
                    size="small"
                    value={filter.version}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        version: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[1, 2].map((version, idx) => (
                      <MenuItem key={idx} value={version} name={version}>
                        {["", "1.0", "2.0"][version]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sm={6} md={3}>
                <FormControl>
                  <InputLabel size="small">类别</InputLabel>
                  <Select
                    label="类别"
                    size="small"
                    value={filter.category}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        category: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[1, 2, 3, 4].map((category, idx) => (
                      <MenuItem key={idx} value={category} name={category}>
                        {["", "绿色积分", "红色积分", "消费积分", "公益积分"][category]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sm={6} md={3}>
                <FormControl>
                  <InputLabel size="small">类型</InputLabel>
                  <Select
                    label="类型"
                    size="small"
                    value={filter.type}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        type: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[-1, ...types].map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {idx == 0 ? "全部" : POINT_RECORD_TYPE_MAP[type]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sm={6} md={3}>
                <FormControl>
                  <InputLabel size="small">用户/商家</InputLabel>
                  <Select
                    label="用户/商家"
                    size="small"
                    value={filter.isMer}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        isMer: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[0, 1].map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {["用户", "商家"][type]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, user, merchant, detail, amount, current, currentLocked, createdAt, remark, type, uid } = row;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        <TableCell align="left">{id}</TableCell>
                        {/* <TableCell align="left">{filter.isMer ? '商家' : ''}{uid}</TableCell> */}
                        <TableCell component="th" scope="row">
                          {filter.isMer ? !!merchant && <MerchantInfo enablePreview {...merchant} /> : !!user && <UserInfo {...user} enablePreview />}
                        </TableCell>
                        <TableCell align="left">{StringUtil.trimZero(amount)}</TableCell>
                        <TableCell align="left">{StringUtil.trimZero(current)}</TableCell>
                        <TableCell align="left"> {POINT_RECORD_TYPE_MAP[type]}</TableCell>
                        <TableCell align="left">{detail}</TableCell>
                        <TableCell align="left">{remark}</TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
